// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import LoadingContainer from "components/layout/LoadingContainer";
import Loader, { StyledLoaderWrapperFullWidth } from "components/layout/Loader";
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardBody } from "components/layout/Card/CardBody";
import { GalleryListItemContent } from "./GalleryListItemContent";

// #####################################################

const GalleryList = ({ emptyText, triggerRef, galleriesKey }) => {
	const gallery = useSelector((state) => state[galleriesKey]);

	const items = useMemo(() => {
		return gallery?.data.map((galleryItem) => {
			return (
				<GalleryListItemContent
					key={galleryItem.id}
					galleryItem={galleryItem}
				/>
			);
		});
	}, [gallery?.data, gallery?.mediaType]);

	// #####################################################

	return (
		<>
			{!gallery?.loading &&
				gallery?.loaded &&
				gallery?.data?.length === 0 && (
					<CardWrapper>
						<CardBody>
							<LoadingContainer
								empty
								noContentText={emptyText}
								loaderDefault
							/>
						</CardBody>
					</CardWrapper>
				)}

			{gallery?.data?.length > 0 && gallery.format !== "short" && (
				<>{items}</>
			)}

			{gallery?.loading && (
				<CardWrapper>
					<CardBody>
						<StyledLoaderWrapperFullWidth noMargin>
							<Loader />
						</StyledLoaderWrapperFullWidth>
					</CardBody>
				</CardWrapper>
			)}

			{!gallery?.loading &&
				gallery.format !== "short" &&
				!(
					gallery?.pagination?.currentpage > 0 &&
					gallery?.data?.length === 0
				) && (
					<div
						ref={triggerRef}
						style={{ height: "1px", pointerEvents: "none" }}
					/>
				)}
		</>
	);
};

// #####################################################

export default GalleryList;

// #####################################################
